import { get } from 'svelte/store';
import { format } from 'svelte-i18n';

/**
 * Maps a Gen 2+ OTA progress percentage to the localized status copy
 * shown next to the progress bar (e.g. "downloading update", "installing update").
 *
 * Bands match the standalone updating view (DeviceUpdatingView.svelte) so the
 * settings-screen in-progress block stays in lock-step with it.
 */
export function getFirmwareProgressMessage(progress: number): string {
	const $format = get(format);

	if (progress >= 0 && progress < 25) {
		return $format('progress_state_initializing_update', {
			default: 'initializing update',
		});
	} else if (progress >= 25 && progress < 50) {
		return $format('progress_state_downloading_update', {
			default: 'downloading update',
		});
	} else if (progress >= 50 && progress < 75) {
		return $format('progress_state_installing_update', {
			default: 'installing update',
		});
	} else if (progress >= 75 && progress < 95) {
		return $format('progress_state_configuring', {
			default: 'Configuration',
		});
	} else if (progress >= 95 && progress < 100) {
		return $format('progress_state_finalizing_update', {
			default: 'Finalizing',
		});
	}

	return '';
}
